<template>
  <div>
    <vx-card class="">
      <div>
        <div class="flex items-center w-full">
          <div class="w-1/2 pr-2">
            <label class=" col-form-label form-control-label"
              >Student Name</label
            >

            <base-input placeholder="Enter Student Name"></base-input>
          </div>

          <div class="w-1/2 pl-2">
            <label class=" col-form-label form-control-label">Phone no.</label>

            <base-input placeholder="Enter Phone no."></base-input>
          </div>
        </div>

        <div class=" flex items-center">
          <div class="w-1/2 pr-2">
            <label class=" col-form-label form-control-label">Email ID</label>

            <base-input placeholder="Enter your EmailID"></base-input>
          </div>
          <div class="w-1/2 pl-2">
            <label class=" col-form-label form-control-label">Name</label>

            <base-input placeholder="Enter Course Name"></base-input>
          </div>
        </div>
        <div class="mb-4 ">
          <div class="w-1/2 pr-2">
            <label class=" col-form-label form-control-label"
              >Course Type</label
            >
            <base-input class="">
              <select class="form-control ">
                <option>Premium</option>
                <option> Regular </option>
              </select>
            </base-input>
          </div>
        </div>
        <!-- <div class="mb-4 ">
          <div>
            <label class=" col-form-label form-control-label"
              >Author Designation</label
            >

            <textarea
              class="form-control"
              placeholder="Enter Author Description"
              id="exampleFormControlTextarea3"
              rows="3"
            ></textarea>
          </div>
        </div>

        <div class="mb-4 flex items-center">
          <div class="w-1/2 pr-2">
            <label class=" col-form-label form-control-label"
              >Course Reader Level</label
            >

            <base-input
              placeholder="Enter Course Reader Level"
              class="mb-0"
            ></base-input>
          </div>

          <div class="w-1/2 pl-2">
            <label class=" col-form-label form-control-label"
              >Course Download Allowed</label
            >

            <base-input
              placeholder="Enter Course Download Allowed"
              class="mb-0"
            ></base-input>
          </div>
        </div>

        <div class="mb-4 flex items-center">
          <div class="w-1/2 pr-2">
            <label class=" col-form-label form-control-label"
              >Signature on Certificate</label
            >

            <base-input
              placeholder="Enter Signature on Certificate"
              class="mb-0"
            ></base-input>
          </div>

          <div class="w-1/2 pl-2">
            <label class=" col-form-label form-control-label">INR Price</label>

            <base-input placeholder="Enter INR Price" class="mb-0"></base-input>
          </div>
        </div>

        <div class="mb-4 flex items-center">
          <div class="w-1/2 pr-2">
            <label class=" col-form-label form-control-label"
              >Signature on Certificate</label
            >

            <base-input
              placeholder="Enter Signature on Certificate"
              class="mb-0"
            ></base-input>
          </div>

          <div class="w-1/2 pl-2">
            <label class=" col-form-label form-control-label">INR Price</label>

            <base-input placeholder="Enter INR Price" class="mb-0"></base-input>
          </div>
        </div>

        <div class="mb-4 flex items-center">
          <div class="w-1/2 pr-2">
            <label class=" col-form-label form-control-label">USD Price</label>

            <base-input placeholder="Enter USD Price" class="mb-0"></base-input>
          </div>

          <div class="w-1/2 pl-2">
            <label class=" col-form-label form-control-label"
              >Set Course Expiry in Days
            </label>

            <base-input
              placeholder="Enter Set Course Expiry in Days"
              class="mb-0"
            ></base-input>
          </div>
        </div> -->
        <div class="mb-4 pt-4 flex items-center">
          <base-button icon type="primary">
            <span class="btn-inner--text">Submit</span>
          </base-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import "../../../scss/Index.scss";
export default {};
</script>
